import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { GetRecipesRequest, GetRecipesResponse, Recipe, SaveRecipeRequest, SaveRecipeResponse } from '@models'

@Injectable({
  providedIn: 'root',
})
export class RecipeService {
  private readonly baseUrl = `${environment.api.baseUrl}/content/v1/recipes`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetRecipesRequest): Promise<GetRecipesResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.status !== undefined && params.status !== null)
        httpParams = httpParams.set('status', String(params.status))

      if (params.preparationMethod) httpParams = httpParams.set('preparationMethod', params.preparationMethod)

      if (params.flavor) httpParams = httpParams.set('flavor', params.flavor)

      if (params.difficulty) httpParams = httpParams.set('difficulty', params.difficulty)

      const hasStart = !!params.startModifiedDate
      const hasEnd = !!params.endModifiedDate

      if (hasStart && hasEnd) {
        httpParams = httpParams
          .set('startModifiedDate', params.startModifiedDate!)
          .set('endModifiedDate', params.endModifiedDate!)
      }
    }

    const response = await firstValueFrom(this.http.get<GetRecipesResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Recipe> {
    const response = await firstValueFrom(this.http.get<Recipe>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveRecipeRequest): Promise<SaveRecipeResponse> {
    const response = await firstValueFrom(this.http.post<SaveRecipeResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveRecipeRequest): Promise<SaveRecipeResponse> {
    const response = await firstValueFrom(this.http.put<SaveRecipeResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
